enum EAdminRoles {
    LEADERSHIP = 'Leadership',
    SALES = 'Sales',
    MARKETING = 'Marketing',
}

export enum UserStatusEnum {
    INVITED = 'Invited',
    ACTIVE = 'Active',
    ACCESS_REMOVED = 'Access Removed',
}

export enum StatusEnum {
    Active = 'Active',
    Inactive = 'Inactive',
}

export enum DashBoardCardTitleEnum {
    Admins = 'Admins',
    Partners = 'Partners',
    Members = 'Members',
    Resources = 'Content',
}

export default EAdminRoles;
